import React, { useState, useRef, useEffect } from 'react'
import SelectSearch from 'react-select-search'
import fuzzySearch from '../common/fuzzySearch'
import {countries, appDevices, configBaseUrl} from '../common/data'
import axios from "axios";
import ShareLink from 'react-twitter-share-link';
import SharefbLink from 'react-facebook-share-link';
import Modal from "react-modal";
import TrialUserRegistrationForm from "../common/TrialUserRegistrationForm";

const AppPackLive = props => {

	console.log('in AppPackLive - b444')

	const toolName = 'app_search_simulator'
	const toolUrl = 'app_search_simulator'
	const toolType = 'app_search'
	const featureId = 'APP_SEARCH_SIMULATOR_SEARCHES'

	const { env, devmode, params, mode } = props

	let publicUrl = configBaseUrl[env] + 'build/'
	let baseUrl = configBaseUrl[env]
	const cannotUseDevMode = ['live', 'staging']
	if (!cannotUseDevMode.includes(env) && devmode === 'Y')
		baseUrl = baseUrl + 'app_dev.php/'

	const [location, setLocation] = useState(false)
	const [accountLevel, setAccountLevel] = useState('BASIC')
	const [usageCount, setUsageCount] = useState(0)
	const [maxUsage, setMaxUsage] = useState(0)
	const [isMMUser, setIsMMUser] = useState(false)
	const [userId, setUserId] = useState(0)
	const [registeredForExtendedUsage, setRegisteredForExtendedUsage] = useState(false)
	const [trialUserRegistered, setTrialUserRegistered] = useState(false)

	// form vars
	const [country, setCountry] = useState(205)
	const [keyword, setKeyword] = useState('')

	const [primaryDevice, setPrimaryDevice] = useState(93)
	const [primaryDevice, setPrimaryDevice] = useState(100)

	const [submitted, setSubmitted] = useState(false)
	const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false)
	const [submitButtonLabel, setSubmitButtonLabel] = useState('RUN LIVE TEST')
	const [usageAllowed, setUsageAllowed] = useState(true)

	const [validUrl, setValidUrl] = useState(false)
	const [validForm, setValidForm] = useState(false)

	const [shareUrlLink, setShareUrlLink] = useState('')
	const [shareUrlText, setShareUrlText] = useState('')
	const [shareFbUrlLink, setShareFbUrlLink] = useState('')

	const [displayTrialUserRegistrationFormModalIsOpen, setDisplayTrialUserRegistrationFormModalIsOpen] = useState(false);

	const twitterTab = useRef(null)
    const fbTag = useRef(null)

	useEffect(() => {
		let setLocationParam = true;
		axios.get(baseUrl + 'tools/can-use-tool/' + toolUrl + '?set_location=' + setLocationParam + '&mode=' + mode)
			.then(r => {
				console.log('can-use-tool response:', r.data)
				if( r.data.location )
					setLocation(r.data.location)
				if( r.data.accountLevel )
					setAccountLevel(r.data.accountLevel)

				if( mode === 'demo' ) {
					if (r.data.userId && r.data.userId > 0) {
						setUserId(r.data.userId)
						// setPublicUsage(false)
						if (r.data.isMMUser)
							setIsMMUser(r.data.isMMUser)
						if (r.data.accountLevel)
							setAccountLevel(r.data.accountLevel)
					} else {
						// setPublicUsage(true)
						if (r.data.publicUsageAccessDetails.maxUsage)
							setMaxUsage(r.data.publicUsageAccessDetails.maxUsage)
						if (r.data.publicUsageAccessDetails.usageCount)
							setUsageCount(r.data.publicUsageAccessDetails.usageCount)
					}
				}

				if (r.data.location.country_code) {
					console.log('set country to ', r.data.location.country_code)
					setCountry(r.data.location.country_code)
				}
			})
			.catch(e => {
				console.log(e)
			})

		window.addEventListener('copyToClipboard',(data)=>{
	        console.log('copyToClipboard data',data.detail);
	            if(data.detail.sharingLink != '')
	            {
	            	navigator.clipboard.writeText(data.detail.sharingLink)
	            }
	          window.removeEventListener('copyToClipboard', null)
	    })

	    window.addEventListener('twitterbtn',(data)=>{
	        console.log('twitterbtn data',data.detail);
	            if(data.detail.url != '')
	            {
	            	setShareUrlLink(data.detail.url)
	            	setShareUrlText(data.detail.message)
	            	twitterTab.current.click()
	            }
	          window.removeEventListener('twitterbtn', null)
	    })

	    window.addEventListener('facebookbtn',(data)=>{
	        console.log('facebookbtn data',data.detail);
	            if(data.detail.url != '')
	            {
	            	fbTag.current.click()
	            	setShareFbUrlLink(data.detail.url)
	            }
	          window.removeEventListener('facebookbtn', null)
	    })

		if( params > '') {
			let paramsParts = JSON.parse(params)
			if (paramsParts.app_keyword ) {
				setKeyword(paramsParts.app_keyword)
			}
			if (paramsParts.country_code ) {
				setCountry(paramsParts.country_code)
			}
			if (paramsParts.device1) {
				setPrimaryDevice(paramsParts.device1)
			}
			if (paramsParts.device2) {
				setSecondaryDevice(paramsParts.device2)
			}
		}
	}, [])

	useEffect(() => { validateForm() }, [ keyword, country, primaryDevice, secondaryDevice ])

	if( mode === 'demo' ) {

		useEffect(() => {
			console.log('TUR - trialUserRegistered', trialUserRegistered)
			// will be updated after the user registers
			if( trialUserRegistered )
				setSubmitButtonDisabled(false)
				setUsageAllowed(true)
			}, [ trialUserRegistered ])

		useEffect(() => {
			if( usageAllowed)
				setSubmitButtonLabel('RUN LIVE TEST')
			else
				setSubmitButtonLabel('REGISTER FOR MORE TRIES')
			}, [ usageAllowed ])

		useEffect(() => {
			console.log('TUR - usageCount or maxUsage changed', registeredForExtendedUsage, usageCount, maxUsage)
			checkUsage()
		}, [usageCount, maxUsage])
	}

	const checkUsage = () => {
		if (userId === 0 && !registeredForExtendedUsage && maxUsage > 0 && usageCount > maxUsage) {
			console.log('TUR - display reg form 1')
			setSubmitButtonDisabled(true)
			setUsageAllowed(false)
			setDisplayTrialUserRegistrationFormModalIsOpen(true)
		} else if (userId === 0 && registeredForExtendedUsage && maxUsage > 0 && usageCount > maxUsage) {
			setTimeout(() => {
				console.log('TUR - reload page 1')
				// window.location.reload();
			}, 1000);
		}
	}

	const checkUsageOnSubmit = () => {
		if (userId === 0 && !registeredForExtendedUsage && maxUsage > 0 && usageCount === maxUsage) {
			console.log('TUR - display reg form 2')
			setSubmitButtonDisabled(true)
			setUsageAllowed(false)
			setDisplayTrialUserRegistrationFormModalIsOpen(true)
		} else if (userId === 0 && registeredForExtendedUsage && maxUsage > 0 && usageCount === maxUsage) {
			setTimeout(() => {
				console.log('TUR - reload page 2')
				window.location.reload()
			}, 1000);
		}
	}

	const handleFetchEmulatorHtml = () => {
		let phoneIds = []
		if (primaryDevice > 0)
			phoneIds.push(primaryDevice)
		if (secondaryDevice > 0)
			phoneIds.push(secondaryDevice)

		var params = {
			'type': toolType,
			'tool': toolName,
			'feature_htmloutput': 0,
			'feature_htmloutputBot': 0,
			'feature_screenshothtmloutput': 0,
			'app_keyword': keyword,
			'phoneids_arr': phoneIds,
			'public_usage': mode !== 'member',
			'mm_mode': mode,
		};

		if( isNaN(country)) {
			params.country_code = country
			params.country = country
		}
		else
			params.country_id = country

		// console.log('params', params)

		axios.post(baseUrl + 'tools/display/' + toolUrl, {'params': params})
			.then(r => {
				document.getElementById('emulator_div').innerHTML = r.data
				setSubmitButtonDisabled(false)
			})
			.catch(e => {
				console.log(e)
			})
	}

	const validateForm = () => {
		setSubmitted(false)

		const isValidForm = country !== '' && keyword !== '' && (primaryDevice > 0 || secondaryDevice > 0)
		setValidForm(isValidForm)

		setSubmitButtonDisabled(!isValidForm)

		console.log('in validateForm', isValidForm)
	}

	const submitFormClick = () => {
		console.log('in submitFormClick, validForm=',validForm)
		// set form as submitted (if valid)
		setSubmitted(validForm)

		if( validForm ) {
			if( mode === 'demo' ) {
				if( userId > 0 )
					handleFetchEmulatorHtml()
				else {
					if (usageAllowed) {
						if (usageCount < maxUsage) {
							setUsageCount(usageCount + 1)
							handleFetchEmulatorHtml()
						} else
							checkUsageOnSubmit()
					} else if (!registeredForExtendedUsage) {
						setDisplayTrialUserRegistrationFormModalIsOpen(true)
					}
				}
			} else
				handleFetchEmulatorHtml()
			setSubmitButtonDisabled(true)
		}
	}

	const standardModalStyles = {
		content: {
			top: '50%',
			left: '50%',
			right: 'auto',
			bottom: 'auto',
			marginRight: '-50%',
			transform: 'translate(-50%, -50%)',
			border: 'none',
			padding: 0,
			background: 'transparent'
		},
	};

	// close modal
	function displayTrialUserRegistrationFormModalClose() {
		setDisplayTrialUserRegistrationFormModalIsOpen(false)
	}

	return (
		<div className='PageoscopeLive'>
			<div className='container-fluid'>
				<div className='row'>
					<ShareLink link={shareUrlLink} text={shareUrlText}>
	                  {link => (
	                     <a ref={twitterTab} href={link} target='_blank' className="hidden">Share this on Twitter</a>
	                  )}
	                </ShareLink>
	                <SharefbLink link={shareFbUrlLink}>
					   {link => (
					      <a ref={fbTag} href={link} target='_blank' className="hidden">Share this on Facebook</a>
					   )}
					</SharefbLink>
					<div className='tab-content live-testing'>
						<div id="simulator_control_tab">
							<div className='row'>
								<div className='col-xs-12 col-sm-4 col-md-3'>
									<label className='control-label'>Country <span className='required'>*</span></label>
									<div className='form-group has-feedback has-error'>
										<div className='input-section'>
											<SelectSearch
												search
												autoComplete='nope'
												emptyMessage='Not found'
												placeholder='Select a country'
												value={country}
												options={countries}
												filterOptions={fuzzySearch}
												onChange={setCountry} />
										</div>
										{submitted && country === '' && (<span className='error'>Please choose a country from the list above</span>)}
									</div>
								</div>
								<div className='col-xs-12 col-sm-8 col-md-9'>
									<label className='control-label'>App Pack Keyword <span className='required'>*</span></label>
									<div className={submitted && keyword === '' ? 'form-group has-feedback has-error' : 'form-group has-feedback'}>
										<div className='input-section'>
											<input type='text' value={keyword} onChange={e => setKeyword(e.target.value)} className='form-control' />
										</div>
										{submitted && keyword === '' && (<span className='error'>Please enter a keyword</span>)}
									</div>
								</div>
							</div>

							<div className='row mt-10'>
								<div className='col-xs-12 col-sm-6'>
									<label className='control-label'>First Device <span className='required'>*</span></label>
									<div className='form-group has-feedback has-error'>
										<div className='input-section'>
											<SelectSearch
												search
												autoComplete='nope'
												emptyMessage='Not found'
												placeholder='Select a device'
												value={primaryDevice}
												options={appDevices}
												filterOptions={fuzzySearch}
												onChange={v => setPrimaryDevice(parseInt(v))} />
										</div>
										{submitted && primaryDevice === '' && (<span className='error'>Please choose a device from the list above</span>)}
									</div>
								</div>
								<div className='col-xs-12 col-sm-6'>
									<label className='control-label'>Second Device (optional)</label>
									<div className='form-group'>
										<div className='input-section'>
											<SelectSearch
												search
												autoComplete='nope'
												emptyMessage='Not found'
												placeholder='Select a device'
												value={secondaryDevice}
												options={appDevices}
												filterOptions={fuzzySearch}
												onChange={v => setSecondaryDevice(parseInt(v))} />
										</div>
									</div>
								</div>
							</div>
							<div className='row'>
								<div className="col-xs-12 text-center text-center-xs mt-20">
									<input disabled={submitButtonDisabled} type="button" className="btn btn-primary" value={submitButtonLabel} onClick={() => submitFormClick()} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="search-results-container tool-ui">
				<div id='emulator_div' className="results-wrapper"></div>
			</div>

			<div className={'row' + (mode === 'member' ? ' mb-80' : '')}>
				<div className="col-xs-12">
					<div className={mode === 'member' ? 'pa-20 bg-white' : 'pt-20'}>
						<div className="row">
							<div className="col-xs-12 text-center captcha-note">
								Note about CAPTCHAs:<br />
								As you explore our Toolset, you may encounter CAPTCHA in your searches. Please click
								through the CAPTCHA, as this will help Google recognize that our users are indeed humans
								and not robots. Thanks!
							</div>
						</div>
					</div>
				</div>
			</div>

			<Modal
				isOpen={displayTrialUserRegistrationFormModalIsOpen}
				onRequestClose={displayTrialUserRegistrationFormModalClose}
				contentLabel="User Registration"
				style={standardModalStyles}
			>
				<TrialUserRegistrationForm
					publicUrl={publicUrl}
					baseUrl={baseUrl}
					toolUrl={toolUrl}
					setUsageAllowed={setUsageAllowed}
					setRegisteredForExtendedUsage={setRegisteredForExtendedUsage}
					setMaxUsage={setMaxUsage}
					setTrialUserRegistered={setTrialUserRegistered}
					displayTrialUserRegistrationFormModalClose={displayTrialUserRegistrationFormModalClose}
				/>
			</Modal>

		</div>
	)
}

export default AppPackLive